import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  adminDashboard: "/admin/dashboard",
};

// Buscar dados do dashboard administrativo
export const fetchAdminDashboard = createAsyncThunk(
  "adminDashboard/fetchAdminDashboard",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.adminDashboard, {
        params,
      });
      return response.data.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro ao carregar dashboard administrativo",
        });
      }
    }
  },
);
